/*
 * @Author: Dong
 * @Date: 2022-04-20 11:14:22
 * @LastEditors: zhang lin
 * @LastEditTime: 2023-02-13 11:01:56
 */
import { SET_IS_MULTI_TENANT, SET_DOMAIN } from '../constant';

export const setIsMultiTenant = (payload: boolean) => ({
  type: SET_IS_MULTI_TENANT,
  payload,
});

export const setDomain = (payload: string) => ({
  type: SET_DOMAIN,
  payload,
});
